import pkg from '../../package.json';

export function getVersion() {
    return pkg.version;
}